export default "__VITE_ASSET__Bwgtnbvt__"